import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import EventListItem from 'components/event-list-item'
import { formatDateTimeNice } from 'utils/datetime'
import { getPartnerUrl } from 'utils/urls'

import styles from './event-list.css'
import { EventGroupPurchaseTypes } from '../../constants/eventgroup-constants'

const EventList = ({ dateField, events, partnerId, subtitle, title }) => (
  <div styleName="event-list">
    <h2 styleName="title">{title}</h2>
    <h3 styleName="subtitle">{subtitle}</h3>

    {events && events.map((eventGroup, index) => (
      <EventListItem
        addNewDatesUrl={eventGroup.addNewDatesUrl}
        currencyCode={eventGroup.market.currency.code}
        date={formatDateTimeNice(eventGroup[dateField])}
        eventUrl={getPartnerUrl(partnerId, `/event/${eventGroup.id}`)}
        isVoucher={eventGroup.purchaseType === EventGroupPurchaseTypes.VOUCHER}
        key={index} // eslint-disable-line react/no-array-index-key
        name={eventGroup.name}
        soldTickets={eventGroup.soldTickets}
        totalPartnerShare={eventGroup.totalPartnerShare}
        venue={eventGroup.venue.name}
      />
    ))}
  </div>
)

EventList.propTypes = {
  dateField: PropTypes.string,
  events: PropTypes.array,
  partnerId: PropTypes.any,
  subtitle: PropTypes.string,
  title: PropTypes.string,
}

export default CSSModules(EventList, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/event-list/event-list.js
 **/